import CollapseSidebarProcessStepsLayout from 'components/common/CollapseSidebarProcessStepsLayout';
import { DESKTOP_MIN_WIDTH, RECEIVERS_PREFIX } from 'constants';
import withTriggerShowCancelUpdateReceiverModal from 'features/receiver/HOCs/withTriggerShowCancelUpdateReceiverModal';
import withTriggerShowUpdateCompletedModal from 'features/receiver/HOCs/withTriggerShowUpdateCompletedModal';
import withUpdateReceiverPageCleanup from 'features/receiver/HOCs/withUpdateReceiverPageCleanup';
import withUpdateReceiverPageInitial from 'features/receiver/HOCs/withUpdateReceiverPageInitial';
import AccountDetails from 'features/receiver/components/AccountDetails';
import PersonalDetails from 'features/receiver/components/PersonalDetails';
import ResidentialAddress from 'features/receiver/components/ResidentialAddress';
import useAddReceiver from 'hooks/form-add-receiver/useAddReceiver';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import useCountryConfig from 'hooks/useCountryConfig';
import useLang from 'hooks/useLang';
import usePreventBrowserBackButton from 'hooks/usePreventBrowserBackButton';
import styled from 'styled-components';

const UpdateReceiverPage = withUpdateReceiverPageCleanup(
  withUpdateReceiverPageInitial(
    withTriggerShowCancelUpdateReceiverModal(
      withTriggerShowUpdateCompletedModal((props) => {
        const { handleOnToggleCancelPopup } = props || {};

        // Backing into the abandoned update-receiver flow must land on the receivers
        // list, the destination this flow's own cancel exit already uses
        // (features/receiver/HOCs/withTriggerShowCancelUpdateReceiverModal.jsx:20).
        usePreventBrowserBackButton(RECEIVERS_PREFIX);

        const { t } = useLang();
        const { getNavbarsAndBodyContentOfSidebar } = useAddReceiver();
        const {
          editReceiverCurrentStep: currentStep,
          setEditReceiverCurrentStep: setCurrentStep,
        } = useFormAddReceiverStore();
        const countryConfig = useCountryConfig();
        const navbars = getNavbarsAndBodyContentOfSidebar();

        const stepContentReference = {
          0: (
            <PersonalDetails
              countryConfig={countryConfig}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              handleOnToggleCancelPopup={handleOnToggleCancelPopup}
            />
          ),
          1: (
            <ResidentialAddress
              countryConfig={countryConfig}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              handleOnToggleCancelPopup={handleOnToggleCancelPopup}
            />
          ),
          2: (
            <AccountDetails
              countryConfig={countryConfig}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              handleOnToggleCancelPopup={handleOnToggleCancelPopup}
            />
          ),
        };

        if (currentStep >= 4) return null;
        return (
          <UpdateReceiverPageStyled>
            <CollapseSidebarProcessStepsLayout
              titleSidebar={t('edit_receiver_title')}
              navbars={navbars}
              currentStep={currentStep}
              stepContentReference={stepContentReference}
              isPreview={false}
              isSuccess={currentStep === 3}
            />
          </UpdateReceiverPageStyled>
        );
      }),
    ),
  ),
);

const UpdateReceiverPageStyled = styled.div`
  margin: 70px 0px 0px 0px;
  padding: 16px;
  height: calc(100dvh - 70px);
  width: 100%;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin: unset;
    margin-top: 0px;
    padding: unset;
    padding-top: 96px;
    height: fit-content;
    min-height: 100dvh;
  }
`;

export default UpdateReceiverPage;
